// extracted by mini-css-extract-plugin
module.exports = {"content":"News_content__2Bed1","newsContainer":"News_newsContainer__cE7V9","newsItem":"News_newsItem__1Lfql","date":"News_date__6-sln","description":"News_description__3TeN_"};